module.exports = "img/slide1.4d2fde.png";